import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import { Col, Row, Container, Button, Card, CardHeader, CardBody } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Fn_AddEditData,
  Fn_DisplayData,
  Fn_FillListData,
} from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";

function AddEdit_Broker() {
  const API_URL_SAVE = `${API_WEB_URLS.LedgerMaster}/0/token`;
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/BrokerAccount`;
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/BrokerAccountEdit/Id`;
  const API_URL1 = API_WEB_URLS.MASTER + "/0/token/CityMasterById";
  const API_URL2 = API_WEB_URLS.MASTER + "/0/token/StateMaster";

  const [state, setState] = useState({
    id: 0,
    FillArrayL: [
      { Id: 43, Name: "Broker A/c" },
    ],
    CityArray: [],
    StateArray: [],
    FillArray: [],
    formData: {
      Name: "",
      Person: "",
      Address: "",
      F_CityMaster: "",
      F_StateMaster: "",
      IFS: "",
      PanNo: "",
      PhoneNo: "",
      MobileNo: "",
      Email: "",
      Fax: "",
      GSTNo: "",
      AccNo: "",
      IsActive: true,
    },
    isProgress: true,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "CityArray", API_URL1 + "/Id/0");
    Fn_FillListData(dispatch, setState, "StateArray", API_URL2 + "/Id/0");
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0");
  }, []);

  // Fetch data when editing
  useEffect(() => {
    const fetchData = async () => {
      const Id = location.state?.Id || 0;
      
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }));

      if (Id > 0) {
        try {
          await Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
        } catch (error) {
          console.error("Error fetching broker data:", error);
        }
      }
    };

    fetchData();
  }, [dispatch, location.state]);

  const handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser")) || {};
    const formData = new FormData();

    Object.keys(values).forEach((key) => {
      let value = values[key];
      
      if (key === "IsActive") {
        formData.append(key, value);
        return;
      }
      
      if (value === null || value === undefined) {
        value = "";
      } else if (typeof value === "boolean") {
        value = value ? "true" : "false";
      } else if (typeof value === "number") {
        value = value.toString();
      } else {
        value = value.toString();
      }
      
      formData.append(key, value);
    });
    
    // Group 43 = Broker A/c
    formData.append("UserId", obj.Id || obj.uid || 0);
    formData.append("F_LedgerGroupMaster", "43");

    return Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/BrokerMaster"
    );
  };

  return (
    <div className="page-content">
      <style>{`
        @media (min-width: 769px) {
          .page-content .container-fluid {
            padding-top: 3rem !important;
          }
        }
        @media (max-width: 768px) {
          .page-content .container-fluid {
            padding-top: 1rem !important;
          }
        }
      `}</style>
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg="10" xl="8">
            <Card className="shadow-sm border-0">
              <CardHeader className="bg-primary text-white text-center py-3">
                <h4 className="mb-0">
                  <i className="fas fa-handshake me-2"></i>
                  {state.id > 0 ? "Edit Broker Details" : "Add New Broker (Dalal)"}
                </h4>
              </CardHeader>
              
              <CardBody className="p-4">
                <Formik
                  initialValues={state.formData}
                  enableReinitialize={true}
                  onSubmit={handleSubmit}
                >
                  {({ values, isSubmitting, setFieldValue }) => (
                    <Form>
                      {/* Basic Information */}
                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-user-tie me-1 text-primary"></i>
                              Broker / Firm Name <span className="text-danger">*</span>
                            </label>
                            <Field
                              className="form-control form-control-lg"
                              type="text"
                              name="Name"
                              placeholder="Enter broker or firm name"
                              required
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-user me-1 text-primary"></i>
                              Contact Person
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="Person"
                              placeholder="Enter contact person name"
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* Address Information */}
                      <Row>
                        <Col lg="12" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-map-marker-alt me-1 text-primary"></i>
                              Address / Station
                            </label>
                            <Field
                              as="textarea"
                              className="form-control"
                              name="Address"
                              placeholder="Enter address or station details"
                              rows="3"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-map me-1 text-primary"></i>
                              State
                            </label>
                            <Field
                              as="select"
                              className="form-control"
                              name="F_StateMaster"
                              onChange={(e) => {
                                setFieldValue("F_StateMaster", e.target.value);
                                Fn_FillListData(
                                  dispatch,
                                  setState,
                                  "CityArray",
                                  API_URL1 + "/Id/" + e.target.value
                                );
                              }}
                            >
                              <option value="">Select State</option>
                              {state.StateArray && state.StateArray.map((item) => (
                                <option key={item.Id} value={item.Id}>
                                  {item.Name}
                                </option>
                              ))}
                            </Field>
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-city me-1 text-primary"></i>
                              City
                            </label>
                            <Field
                              as="select"
                              className="form-control"
                              name="F_CityMaster"
                            >
                              <option value="">Select City</option>
                              {state.CityArray && state.CityArray.map((item) => (
                                <option key={item.Id} value={item.Id}>
                                  {item.Name}
                                </option>
                              ))}
                            </Field>
                          </div>
                        </Col>
                      </Row>

                      {/* Contact & Statutory Information */}
                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-mobile-alt me-1 text-primary"></i>
                              Mobile No
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="MobileNo"
                              placeholder="Enter mobile number"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-phone me-1 text-primary"></i>
                              Phone No
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="PhoneNo"
                              placeholder="Enter telephone number"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-envelope me-1 text-primary"></i>
                              Email
                            </label>
                            <Field
                              className="form-control"
                              type="email"
                              name="Email"
                              placeholder="Enter email address"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-id-card me-1 text-primary"></i>
                              PAN No
                            </label>
                            <Field
                              className="form-control text-uppercase"
                              type="text"
                              name="PanNo"
                              placeholder="Enter PAN number"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-file-invoice me-1 text-primary"></i>
                              GST No
                            </label>
                            <Field
                              className="form-control text-uppercase"
                              type="text"
                              name="GSTNo"
                              placeholder="Enter GST number"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-university me-1 text-primary"></i>
                              Bank Account No
                            </label>
                            <Field
                              className="form-control"
                              type="text"
                              name="AccNo"
                              placeholder="Enter bank account number"
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-code-branch me-1 text-primary"></i>
                              IFSC Code
                            </label>
                            <Field
                              className="form-control text-uppercase"
                              type="text"
                              name="IFS"
                              placeholder="Enter IFSC code"
                            />
                          </div>
                        </Col>

                        <Col lg="6" className="mb-3">
                          <div className="form-group">
                            <label className="form-label fw-semibold text-dark">
                              <i className="fas fa-toggle-on me-1 text-primary"></i>
                              Status
                            </label>
                            <div className="form-check form-switch mt-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="brokerIsActive"
                                checked={values.IsActive}
                                onChange={(e) => setFieldValue("IsActive", e.target.checked)}
                              />
                              <label className="form-check-label fw-semibold ms-2" htmlFor="brokerIsActive">
                                {values.IsActive ? "Active" : "Inactive"}
                              </label>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {/* Action Buttons */}
                      <Row className="mt-4">
                        <Col lg="12" className="text-end">
                          <Button
                            type="button"
                            color="secondary"
                            className="me-2 px-4"
                            onClick={() => navigate("/BrokerMaster")}
                          >
                            <i className="fas fa-times me-1"></i> Cancel
                          </Button>
                          <Button
                            type="submit"
                            color="primary"
                            className="px-4"
                            disabled={isSubmitting}
                          >
                            <i className="fas fa-save me-1"></i> Save Broker
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AddEdit_Broker;
